TODO
Make this into a webworker
https://www.w3.org/TR/webaudio/#todo-fix-up-this-example.-a-volume-meter-and-clip-detector

<template>
  <canvas class="vu" ref="vu"></canvas>
</template>

<script>
import { mapGetters } from 'vuex';
import { Meter } from '../../audio';

export default {
  computed: {
    ...mapGetters([
      'power'
    ])
  },

  props: {
    audio: null // window.AudioNode
  },

  created() {
    this.meter = new Meter();
    this.ticking = true;

    this.$watch('power', (on) => {
      if (on) {
        this.loop();
      } else {
        // set buffer to 0 and update display
      }
    });
  },

  destroyed() {
    // clean up METER // TODO
  },

  mounted() {
    const meterContext = this.meterContext = this.$refs.vu.getContext('2d');
    let meterGraident = this.meterGraident = meterContext.createLinearGradient(0, 0, 0, 132);

    this.audio.connect && this.audio.connect(this.meter);

    meterContext.canvas.width = 20;
    meterContext.canvas.height = 132;

    meterGraident.addColorStop(0, '#BFFF02');
    meterGraident.addColorStop(0.8, '#02FF24');
    meterGraident.addColorStop(1, '#FF0202');
  },

  methods: {
    draw() {
      const level = this.meter.volume; // * 0.8; // scale it since values go above 1 when clipping
      const meterContext = this.meterContext;

      //                     x, y, width, height
      meterContext.clearRect(0, 0, 20, 132);
      meterContext.fillStyle = this.meterGraident;
      meterContext.fillRect(0, 0, 20, 132);
      meterContext.fillStyle = 'black';
      meterContext.fillRect(0, 132 * level, 20, 132);
    },

    loop() {
      if (this.power) {
        if (this.ticking) {
          this.draw();
        }

        this.ticking = !this.ticking;
        window.requestAnimationFrame(this.loop);
        // } else {
        // this.draw();    // draw one final to clear canvas
      }
    }
  }
};

</script>

<style lang="scss">
  canvas.vu {
    background: black;
    width: 20px;
    height: 132px;
    transform: rotate(180deg); // meh, i dont feel like figuring out the math in the x,y drawing
  }
</style>



// WEBPACK FOOTER //
// src/components/UI/VU.vue